import { isEmpty } from 'radash';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { GetProductRelatedProductUsecase } from '@modules/products/application/usecases/getRelatedProduct.usecase';
import { userStore } from '@modules/user/adapter/outbound/stores/user.store';
import { IRelatedProduct } from '@shared/models/relatedProduct.model';
import { ProductRelatedProductRepositoryImpl } from '../../inbound/repositories/relatedProduct.repository';
interface ProductRelatedProductState {
  relatedProductList: IRelatedProduct[];
  fetchRelatedProduct: (productId: number) => Promise<void>;
}
export const productRelatedProductStore = create<ProductRelatedProductState>()(devtools(set => ({
  relatedProductList: [],
  fetchRelatedProduct: async (productId: number): Promise<void> => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const user = userStore.getState().userDetail;
      const hasUser = !isEmpty(user);
      const productRelatedProductRepositoryImpl = new ProductRelatedProductRepositoryImpl();
      const getProductRelatedProductUsecase = new GetProductRelatedProductUsecase(productRelatedProductRepositoryImpl);
      const result = await getProductRelatedProductUsecase.handle(productId, hasUser);
      if (result.isRight()) {
        set(() => ({
          relatedProductList: result.value
        }));
      }
    } catch (err) {
      console.error('Error fetchRelatedProduct', err);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  }
})));